import { useState, useEffect, useMemo } from "react";

/** Pagination for the ClientsPage client list. Resets to page 1 whenever resetDeps change. */
export function useClientListPagination<T>(
  filteredItems: T[],
  resetDeps: unknown[],
  initialRowsPerPage = 10,
) {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);

  useEffect(() => {
    setPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, resetDeps);

  const paginatedItems = useMemo(
    () => filteredItems.slice((page - 1) * rowsPerPage, page * rowsPerPage),
    [page, filteredItems, rowsPerPage],
  );

  return { page, setPage, rowsPerPage, setRowsPerPage, paginatedItems };
}
